import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class BrigadePopoverService {
  constructor(private http: HttpClient) {}

  getBrigade(brigade_id) {
    return this.http.get(`/admin/brigades/${brigade_id}/`);
  }
}
